import React from "react";

import Tooltip from "./Tooltip";

interface PaziaTooltipProps {
  description: string | React.ReactNode;
  title?: string;
  children?: React.ReactNode;
  className?: string;
}
export const PaziaTooltip = ({
  children,
  title,
  description,
  className,
}: PaziaTooltipProps) => {
  return (
    <div className={`flex items-center space-x-2 ${className ?? ""}`}>
      <Tooltip size="lg" bg="light">
        <div className="text-xs">
          {title && (
            <div className="font-medium text-slate-800 mb-0.5 dark:text-slate-200">{title}</div>
          )}
          <div>{description}</div>
        </div>
      </Tooltip>
      {children && (
        <div className="text-sm font-medium text-slate-500">{children}</div>
      )}
    </div>
  );
};
